import { Box, Button, Card, CardActionArea, CardContent, CircularProgress, Grid, IconButton, TextField, Typography } from "@mui/material";
import React, { useCallback, useRef, useState } from "react";
import ReactQuill, { ReactQuillProps } from 'react-quill';
import './index.scss'
import AddNotes from "../../../components/notes/add-note";
import ModalEditNote from "../../../components/notes/modal-edit";
import { useProjectsState } from "../../../../hooks/projectsInfo";
import NoteCard from "../../../components/notes/note-card";
import ModalDeleteNote from "../../../components/notes/modal-delete";
import { useListNotesQuery } from "../../../../../graphql/generated/graphql";
import { useUserInfoState } from "../../../../hooks/userInfo";

const NotesPage = () => {

  const projectsState = useProjectsState();
  const currentProject = projectsState.projectId.get();
  const userInfoState = useUserInfoState();
  const [open, setOpen] = useState(false)
  const [openModalDelete, setOpenModalDelete] = useState(false)
  const [toEditTitle, setToEditTitle] = useState('')
  const [toeditContent, setToeditContent] = useState('')
  const [IdNote, setIdNote] = useState<number>()

  const handleEditModal = (open: boolean) => {
    setOpen(open)
  }

  const handleInfoToEditModal = (editTitle: string, editContent: string, idNote: number) => {
    setToEditTitle(editTitle)
    setToeditContent(editContent)
    setIdNote(idNote)
  }

  const handleModalDelete = (open: boolean, needEvent: boolean, event?: any) => {
    if(needEvent) {
      event.stopPropagation()
    }
    setOpenModalDelete(open)
  }

  const handleInfoToDelete = (idNote: number) => {
    setIdNote(idNote)
  }
  
  const {
    data: listNotes,
    loading,
    refetch,
  } = useListNotesQuery({
    variables: {
      project_id: currentProject || "",
      user_id: userInfoState.user.get()?.id as string
    },
  });

  return (
    <>
      <Grid>
        <Typography
          component="h1"
          variant="h2"
          sx={{
            mb: 2,
            fontWeight: 500,
          }}
        >
          Notes
        </Typography>
        <AddNotes
          refetch={refetch}
        />
      </Grid>
      <Grid
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: '64px',
          padding: '8px',
        }}
      >
        {
          listNotes?.listNotes
          && listNotes.listNotes.length > 0
          && listNotes.listNotes.map((note) => {
            return (<NoteCard
              handleModalDelete={handleModalDelete}
              handleInfoToDelete={handleInfoToDelete}
              handleModal={handleEditModal}
              handleInfoToEditModal={handleInfoToEditModal}
              idNote={note?.id as number}
              title={note?.title as string}
              content={note?.content as string}
            />)
          })
        }
      </Grid>
      {
        loading &&
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <CircularProgress
            color="primary"
            size={60}
          />
        </Grid>
      }
      {
        !listNotes?.listNotes ||
        listNotes.listNotes.length === 0
        &&
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{
              textAlign: 'center'
            }}
          >
            There's no notes
          </Typography>
        </Grid>
      }
      <ModalEditNote
        open={open}
        handleModal={handleEditModal}
        title={toEditTitle}
        content={toeditContent}
        idNote={IdNote as number}
        refetch={refetch}
      />
      <ModalDeleteNote
        open={openModalDelete}
        handleModal={handleModalDelete}
        idNoteToDelete={IdNote as number}
        refetch={refetch}
      />
    </>
  )
}

export default NotesPage
